<wdpr-price
    presentation="commerce"
    [hideDecimals]="hideDecimals"
    [roundValue]="hideDecimals"
    [locale]="localeFromGeolocation"
    [value]="pricingData.total"
    [currency]="pricingData.currency">
</wdpr-price>
